"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var config_exports = {};
__export(config_exports, {
  actions: () => actions,
  getters: () => getters,
  mutations: () => mutations,
  state: () => state
});
module.exports = __toCommonJS(config_exports);
function state() {
  return {
    config: {
      language: [
        {
          code: "en",
          name: "English",
          default: true
        }
      ],
      languages: [
        {
          code: "en",
          name: "English",
          default: true
        }
      ]
    }
  };
}
const getters = {
  getActiveLanguage: (state2) => state2.config.language.find((l) => l.default).code,
  getConfig: (state2) => state2.config,
  getSocials: (state2) => {
    const socialList = [];
    const oldSocialList = state2.config.social_links?.map((socialItem) => {
      let iconName = "";
      if (socialItem.url.includes("youtube") || socialItem.url.includes("yt"))
        iconName = "youtube";
      if (socialItem.url.includes("facebook") || socialItem.url.includes("fb.com")) {
        iconName = "facebook";
      }
      if (socialItem.url.includes("twitter") || socialItem.url.includes("x.com")) {
        iconName = "twitter";
      }
      if (socialItem.url.includes("linkedin"))
        iconName = "linkedin";
      if (socialItem.url.includes("instagram"))
        iconName = "instagram";
      return {
        src: socialItem.url,
        name: iconName
      };
    });
    ["instagram", "facebook", "twitter", "youtube", "linkedin"].forEach(
      (socialName) => {
        const seekedSocialItem = oldSocialList?.find(
          (socialItem) => socialItem.name === socialName
        );
        if (seekedSocialItem)
          socialList.push(seekedSocialItem);
      }
    );
    return socialList;
  },
  getGTM(state2) {
    return state2.config?.gtm;
  },
  getFavicon(state2) {
    return state2.config?.favicon;
  },
  getLogotypes(state2) {
    return {
      desktop: state2.config?.logotype_desktop,
      mobile: state2.config?.logotype_mobile
    };
  },
  getLanguages(state2) {
    return state2.config?.languages;
  },
  getDomain(state2) {
    return state2.config?.domain;
  },
  getCDNUrl(state2) {
    return state2.config?.cdn_url;
  }
};
const mutations = {
  setConfig: (state2, config) => state2.config = config
};
const actions = {
  async load({ commit }, { $api, locale }) {
    try {
      const { data } = await $api.siteInfoService.getSiteInfo({ lang: locale });
      commit("setConfig", data);
    } catch (error) {
      console.error(error?.responce);
    }
  }
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  actions,
  getters,
  mutations,
  state
});
